import React from 'react'
import RecentPublications from './Home/RecentPublications'
import Description from './Home/Description'

const MainContent = () => {
  return (
    <>
    <div className="header-wraper">
        <div className='header-content d-flex flex-column justify-content-center text-center container'>
            <div className='lab-name d-flex justify-content-center'> </div> 
            <br/>
        </div>
    </div>
    <Description/>
    <RecentPublications/>
    </>
  )
}

export default MainContent